import * as Yup from 'yup'
import { z, z as zod } from 'zod'

import { DefaultSchemas } from './defaultSchemas'

export const OrdersDetailsWestfieldConsDefaultSchemas = DefaultSchemas

const OrdersDetailsWestfieldConsDetailsCardsDataSchemas = zod.object({
  traderId: zod.number(),
  traderTransIdent: zod.string(),
})

const OrdersDetailsWestfieldConsDetailsDataSchemas = zod.object({
  detailId: zod.string(),
  value: zod.number(),
  quantity: zod.number(),
  productName: zod.number(),
  cards: zod.array(OrdersDetailsWestfieldConsDetailsCardsDataSchemas),
})

export const OrdersCardsSchemas = zod.object({
  orderId: zod.number(),
  orderDate: zod.string(),
  cardNumber: zod.string().nullable(),
  sentTo: zod.string().nullable(),
  sentFrom: zod.string().nullable(),
  message: zod.string().nullable(),
  cardType: zod.string().nullable(),
  address1: zod.string().nullable(),
  address2: zod.string().nullable(),
  suburb: zod.string().nullable(),
  city: zod.string().nullable(),
  state: zod.string().nullable(),
  postCode: zod.string().nullable(),
})

export const OrdersDetailsSchemas = zod.object({
  orderDate: zod.string(),
  cardNumber: zod.string(),
  unitPrice: zod.number(),
  quantity: zod.number(),
  productId: zod.number(),
  orderId: zod.number(),
  productName: zod.string(),
})

export const OrdersDetailsWestfieldConsDataSchemas = zod.object({
  consumerCardDetails: OrdersCardsSchemas.array(),
  consumerOrderDetails: OrdersDetailsSchemas.array(),
})

export const OrdersDetailsWestfieldConsAPISchemas =
  OrdersDetailsWestfieldConsDefaultSchemas.merge(
    zod.object({
      data: OrdersDetailsWestfieldConsDataSchemas.nullable(),
    })
  )

export const OrdersDetailsWestfieldConsFetchParamsSchemas = zod.object({
  orderId: zod.number().optional().nullable(),
})

export const OrdersDetailsWestfieldConsUpdateParamsSchemas = zod.object({
  traderId: zod.number(),
  noteId: zod.number(),
  noteTypeId: zod.string(),
  priorityLevel: zod.string(),
  noteDescription: zod.string(),
  creationDate: zod.string(),
  sourceName: zod.string(),
})
